import { render, staticRenderFns } from "./NeedDetails.vue?vue&type=template&id=ca2c789a&scoped=true&"
import script from "./NeedDetails.vue?vue&type=script&lang=js&"
export * from "./NeedDetails.vue?vue&type=script&lang=js&"
import style0 from "./NeedDetails.vue?vue&type=style&index=0&id=ca2c789a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2c789a",
  null
  
)

export default component.exports